import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("token"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);

    return decryptedData;
};

export const listTenantSlaAction = async () => {
    const authToken = getAuthToken();

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    return new Promise((resolve, reject) => {
        axios
            .get("/api/sla/tenant-sla", {
                headers,
            })
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getTenantSlaByIdAction = async (id) => {
    const authToken = getAuthToken();

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    return new Promise((resolve, reject) => {
        axios
            .get(`/api/sla/tenant-sla/${id}`, {
                headers,
            })
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createTenantSlaAction = async (data) => {
    const authToken = getAuthToken();

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    return new Promise((resolve, reject) => {
        axios
            .post("/api/sla/tenant-sla", data, {
                headers,
            })
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateTenantSlaAction = async (id, data) => {
    const authToken = getAuthToken();

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    return new Promise((resolve, reject) => {
        axios
            .put(`/api/sla/tenant-sla/${id}`, data, {
                headers,
            })
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteTenantSlaAction = async (id) => {
    const authToken = getAuthToken();

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    return new Promise((resolve, reject) => {
        axios
            .delete(`/api/sla/tenant-sla/${id}`, {
                headers,
            })
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateTenantSlaStatusAction = async (id, data) => {
    const authToken = getAuthToken();

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    return new Promise((resolve, reject) => {
        axios
            .patch(`/api/sla/tenant-sla/${id}/status`, data, {
                headers,
            })
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};